import React from "react";
import { Trans } from "react-i18next";
import logo from "./assets/images/Capgemini-StudentConnection-Label.png";
import image from "../../../assets/images/home-banner-2026.jpg";
import progressBar from "../../../assets/images/home-progress-bar.png";

import "./home-banner.scss";

const HomeBanner = () => (

    <header className="home-banner">
        <div className="home-banner__content">
            <div className="home-banner__logo-title-container">
                <img src={logo} alt="Logo" className="home-banner__logo" />
                <Trans parent="h1" className="home-banner__title" i18nKey="home-banner.title" />
            </div>

            <img src={image} alt="" className="img" />
            <img src={progressBar} alt="" className="home-banner__progress-bar" />
        </div>
    </header>
);

export default HomeBanner;